// src/components/seo/HtmlLangSetter.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';


interface HtmlLangSetterProps {
    lang: string;
}

const HtmlLangSetter: React.FC<HtmlLangSetterProps> = ({ lang }) => {

    const htmlLang = lang === 'cn' ? 'zh-Hans'
        : lang === 'tw' ? 'zh-Hant'
            : lang; // pass through other supported langs like 'en', 'fr', etc.


    return <Helmet htmlAttributes={{ lang: htmlLang }} />;
};

export default HtmlLangSetter;
